/**
 * Entry point for the customer-facing order SPA.
 *
 * CSP compliance:
 * - The script tag is inserted by Vite at build time as a same-origin src
 *   reference - compliant with script-src 'self'.
 * - No dynamic code execution patterns anywhere in this file.
 * - Tailwind CSS is injected via style tags (covered by style-src 'unsafe-inline').
 */
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

// Initialize i18n before rendering
import '@/i18n/config'

// Global styles (Tailwind directives + CSS variables)
import '@/styles/globals.css'

import { App } from './App'

const rootEl = document.getElementById('root')
if (!rootEl) {
  throw new Error('Root element #root not found')
}

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
